import { Controller } from "@hotwired/stimulus"

// The How it Works figures (TASK-301.2; app/components/www/figures/**, and the
// standalone ScanFlow register). Each figure's markup IS its finished state.
// This controller does two things, once:
//
//   connect     adds `is-armed`, which puts the figure's animated parts at
//               their START state, paused, so nothing flashes when it plays;
//   in view     adds `is-playing`, which runs the animations to the finished
//               state (animation-fill-mode: both), then stops watching.
//
// Every keyframe and delay lives in www_how_it_works_figures.css. Visitors
// who prefer reduced motion, or who have no JavaScript, never get either
// class and simply see the finished figure.
const THRESHOLD = 0.4

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    if (!("IntersectionObserver" in window)) return

    this.element.classList.add("is-armed")
    this.observer = new IntersectionObserver((entries) => this.observe(entries), { threshold: THRESHOLD, rootMargin: "0px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.observer = null
  }

  observe(entries) {
    entries.forEach((entry) => {
      // A figure taller than 2.5 screens can never be 40% visible; half a
      // viewport of it on screen counts too.
      const enough = entry.intersectionRatio >= THRESHOLD || entry.intersectionRect.height >= window.innerHeight * THRESHOLD
      if (!entry.isIntersecting || !enough) return

      this.element.classList.add("is-playing")
      this.observer.unobserve(this.element)
    })
  }
}
